import HttpService, { BaseResponse } from "../base";
// Types
import { OrderTableRow } from "src/VirtualOMS/types/order";

class OrderProvider extends HttpService {
  constructor() {
    super({ suffix: "Order" });
  }

  public getOrder(userName: string): BaseResponse<any> {
    return this.httpService.get(`Get/${userName}`);
  }

  public openOrder({
    userId,
    userName,
  }: {
    userId: number;
    userName: string;
  }): BaseResponse<any> {
    return this.httpService.get("OpenOrder", {
      params: {
        userId,
        userName,
      },
    });
  }

  public getTrades({
    userId,
    userName,
  }: {
    userId: number;
    userName: string;
  }): BaseResponse<any> {
    return this.httpService.get("Trades", {
      params: {
        userId,
        userName,
      },
    });
  }

  public fillOrder({
    id,
    executedVolume,
  }: {
    id: number;
    executedVolume: number;
  }): BaseResponse<any> {
    return this.httpService.put("FillOrder", {
      id,
      executedVolume,
    });
  }

  public getPortfo(userName: string): BaseResponse<any> {
    return this.httpService.get(`GetPortfo/${userName}`);
  }

  public getPortfoById(userId: number): BaseResponse<any> {
    return this.httpService.get(`GetPortfoWithId/${userId}`);
  }

  public addOrder(userName: string): BaseResponse<any> {
    return this.httpService.post(`Add/${userName}`);
  }
  public addOrderById(userId: number): BaseResponse<any> {
    return this.httpService.post(`AddWithId/${userId}`);
  }

  public openOrder2(userName: string): BaseResponse<any> {
    // TODO: beporse chera 2 tas
    return this.httpService.post(`Open/${userName}`);
  }

  /**
   * OPENOrder tab table
   *
   * @param {string|number} data
   * @async
   * @version 1.0.0
   */
  public getOrderById(id: number): BaseResponse<OrderTableRow[]> {
    return this.httpService.get(`OpenWithId/${id}`);
  }
  public cancelOrder(userName: string): BaseResponse<any> {
    return this.httpService.post(`Cancel/${userName}`);
  }
  public cancelOrderByID(userId: number): BaseResponse<any> {
    return this.httpService.post(`CancelWithId/${userId}`);
  }

  public cancelOpenOrdersById(userId: number, orderIds: number[]): BaseResponse<any> {
    return this.httpService.delete(`CancelWithId/${userId}`, { data: orderIds });
  }

  public resetUserAccount(userId: number): BaseResponse<any> {
    return this.httpService.delete(`ResetUserAccount/${userId}`);
  }
}

const OrderService = new OrderProvider();

export default OrderService;
